import { GET_LANGUAGE } from "../../../api/endPoint";
import instance from "../../../helpers/axios";

const getLanguages = () => {
  return instance.get(GET_LANGUAGE);
};

const languageService = {
  getLanguages,
};

export default languageService;
